import type {File, Image} from '~/types/sofie'
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/composition-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  Email: string;
  Iban: string;
  Image: Image;
  JSON: any;
  MapCoordinate: any;
  Mixed: any;
  Null: null;
  PrivateFile: any;
  PublicFile: any;
  Upload: any;
  Uuid: string;
};

export type ActivityValue = {
  __typename?: 'ActivityValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  capabilities: Array<Capability>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  geodata?: Maybe<Scalars['JSON']>;
  house_number?: Maybe<Scalars['String']>;
  house_number_suffix?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  published: Scalars['Boolean'];
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type BiotopeValue = {
  __typename?: 'BiotopeValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Capability = {
  __typename?: 'Capability';
  name: Scalars['String'];
};

export type Capture = {
  __typename?: 'Capture';
  age?: Maybe<Scalars['Int']>;
  bat?: Maybe<Scalars['String']>;
  bat_sex?: Maybe<Scalars['Int']>;
  bold_molt?: Maybe<Scalars['Int']>;
  buccalglands?: Maybe<Scalars['Int']>;
  capabilities: Array<Capability>;
  chinspot?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  count_parasite?: Maybe<Scalars['Int']>;
  count_spint?: Maybe<Scalars['Int']>;
  created_at: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  dental_plaque?: Maybe<Scalars['Int']>;
  dental_wear?: Maybe<Scalars['Int']>;
  direction?: Maybe<Scalars['String']>;
  epi?: Maybe<Scalars['Int']>;
  epididymis_fill?: Maybe<Scalars['Int']>;
  epididymis_size?: Maybe<Scalars['Int']>;
  fifthfinger?: Maybe<Scalars['Float']>;
  forearm_length?: Maybe<Scalars['Float']>;
  has_escaped?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  location?: Maybe<Location>;
  mammaryglands?: Maybe<Scalars['Int']>;
  net?: Maybe<Net>;
  nipple_bold?: Maybe<Scalars['Int']>;
  observations?: Maybe<Array<Maybe<Observation>>>;
  photo?: Maybe<Scalars['PrivateFile']>;
  ring?: Maybe<Scalars['String']>;
  sexualstatus?: Maybe<Scalars['Int']>;
  species: SpeciesValue;
  tag?: Maybe<Scalars['String']>;
  teat_hair?: Maybe<Scalars['Int']>;
  teat_size?: Maybe<Scalars['Int']>;
  testes?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  transponder?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Float']>;
};

export type CaptureInput = {
  age?: InputMaybe<Scalars['ID']>;
  bat?: InputMaybe<Scalars['String']>;
  bat_sex?: InputMaybe<Scalars['Int']>;
  bold_molt?: InputMaybe<Scalars['ID']>;
  buccalglands?: InputMaybe<Scalars['ID']>;
  capture?: InputMaybe<Scalars['ID']>;
  chinspot?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  count_parasite?: InputMaybe<Scalars['Int']>;
  count_spint?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  dental_plaque?: InputMaybe<Scalars['ID']>;
  dental_wear?: InputMaybe<Scalars['ID']>;
  direction?: InputMaybe<Scalars['String']>;
  epi?: InputMaybe<Scalars['ID']>;
  epididymis_fill?: InputMaybe<Scalars['ID']>;
  epididymis_size?: InputMaybe<Scalars['ID']>;
  fifthfinger?: InputMaybe<Scalars['Float']>;
  forearm_length?: InputMaybe<Scalars['Float']>;
  has_escaped: Scalars['Boolean'];
  location?: InputMaybe<Scalars['ID']>;
  mammaryglands?: InputMaybe<Scalars['ID']>;
  net?: InputMaybe<Scalars['ID']>;
  nipple_bold?: InputMaybe<Scalars['ID']>;
  ring?: InputMaybe<Scalars['String']>;
  sexualstatus?: InputMaybe<Scalars['ID']>;
  species: Scalars['ID'];
  tag?: InputMaybe<Scalars['String']>;
  teat_hair?: InputMaybe<Scalars['ID']>;
  teat_size?: InputMaybe<Scalars['ID']>;
  testes?: InputMaybe<Scalars['ID']>;
  time: Scalars['String'];
  transponder?: InputMaybe<Scalars['String']>;
  visit: Scalars['ID'];
  weight?: InputMaybe<Scalars['Float']>;
};

export type Category = {
  __typename?: 'Category';
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  active_image?: Maybe<Scalars['Image']>;
  ancestors: Array<Category>;
  capabilities: Array<Capability>;
  children: Array<Category>;
  created_at?: Maybe<Scalars['DateTime']>;
  depth?: Maybe<Scalars['Int']>;
  descendants: Array<Category>;
  id: Scalars['Int'];
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  images: Array<Scalars['Image']>;
  name: Scalars['String'];
  parent?: Maybe<Category>;
  parent_id?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  seo?: Maybe<Seo>;
  slug: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};


export type CategoryActive_ImageArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};


export type CategoryImagesArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};

export type CloudcoverValue = {
  __typename?: 'CloudcoverValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type DirectionValue = {
  __typename?: 'DirectionValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type FogValue = {
  __typename?: 'FogValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Form = {
  __typename?: 'Form';
  fields: Array<FormField>;
  id: Scalars['Int'];
  schema: Scalars['JSON'];
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  uuid: Scalars['Uuid'];
};

export type FormData = {
  __typename?: 'FormData';
  fields?: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
};

export type FormField = {
  __typename?: 'FormField';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  regex?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  unique?: Maybe<Scalars['Boolean']>;
};

export type FormVersion = {
  __typename?: 'FormVersion';
  capabilities: Array<Capability>;
  id: Scalars['Int'];
  projects_count: Scalars['Int'];
  score_fields: Array<ScoreField>;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export enum LocaleEnum {
  En = 'en'
}

export type Location = {
  __typename?: 'Location';
  biotope?: Maybe<BiotopeValue>;
  capabilities: Array<Capability>;
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  setup?: Maybe<Setup>;
  title: Scalars['String'];
};

export type Menu = {
  __typename?: 'Menu';
  items?: Maybe<Array<Maybe<MenuItem>>>;
  name?: Maybe<Scalars['String']>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  children?: Maybe<Array<Maybe<MenuItem>>>;
  scope?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MethodValue = {
  __typename?: 'MethodValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite?: Maybe<Scalars['Boolean']>;
  changePassword?: Maybe<Scalars['Null']>;
  createCaptureForVisit: Capture;
  createFormVersion: FormVersion;
  createInitialCaptures?: Maybe<Capture>;
  createProject: Project;
  createVisit: Visit;
  deleteCapture?: Maybe<Scalars['Null']>;
  deleteFormVersion?: Maybe<Scalars['Null']>;
  deleteLocation?: Maybe<Scalars['Null']>;
  deleteNet: Scalars['Boolean'];
  deleteObservation?: Maybe<Scalars['Null']>;
  deleteProject?: Maybe<Scalars['Null']>;
  deleteVisit?: Maybe<Scalars['Null']>;
  disableTwoFactor?: Maybe<Scalars['Boolean']>;
  editFormVersion?: Maybe<Scalars['Null']>;
  editProject?: Maybe<Scalars['Null']>;
  editVisit?: Maybe<Scalars['Null']>;
  enableTwoFactor?: Maybe<Scalars['Boolean']>;
  endVisit: Visit;
  generateTwoFactorSecret?: Maybe<TwoFactorSecret>;
  login?: Maybe<Scalars['String']>;
  logout?: Maybe<Scalars['Boolean']>;
  register?: Maybe<Scalars['Null']>;
  requestPasswordReset?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  saveCapturesTable?: Maybe<Scalars['Null']>;
  submitForm?: Maybe<Scalars['Null']>;
  updateCaptureForVisit: Capture;
  updateOrCreateLocation: Location;
  updateOrCreateNet: Net;
  updateOrCreateObservation: Observation;
  verifyCapture: Capture;
};


export type MutationAcceptInviteArgs = {
  email: Scalars['Email'];
  invite: Scalars['String'];
  password: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  current_password: Scalars['String'];
  new_password: Scalars['String'];
  new_password_confirm: Scalars['String'];
};


export type MutationCreateCaptureForVisitArgs = {
  age?: InputMaybe<Scalars['ID']>;
  bat?: InputMaybe<Scalars['String']>;
  bat_sex?: InputMaybe<Scalars['Int']>;
  bold_molt?: InputMaybe<Scalars['ID']>;
  buccalglands?: InputMaybe<Scalars['ID']>;
  chinspot?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  count_parasite?: InputMaybe<Scalars['Int']>;
  count_spint?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  dental_plaque?: InputMaybe<Scalars['ID']>;
  dental_wear?: InputMaybe<Scalars['ID']>;
  direction?: InputMaybe<Scalars['String']>;
  epi?: InputMaybe<Scalars['ID']>;
  epididymis_fill?: InputMaybe<Scalars['ID']>;
  epididymis_size?: InputMaybe<Scalars['ID']>;
  fifthfinger?: InputMaybe<Scalars['Float']>;
  forearm_length?: InputMaybe<Scalars['Float']>;
  has_escaped: Scalars['Boolean'];
  location: Scalars['ID'];
  mammaryglands?: InputMaybe<Scalars['ID']>;
  net?: InputMaybe<Scalars['ID']>;
  nipple_bold?: InputMaybe<Scalars['ID']>;
  photo?: InputMaybe<Scalars['Upload']>;
  ring?: InputMaybe<Scalars['String']>;
  sexualstatus?: InputMaybe<Scalars['ID']>;
  species: Scalars['ID'];
  tag?: InputMaybe<Scalars['String']>;
  teat_hair?: InputMaybe<Scalars['ID']>;
  teat_size?: InputMaybe<Scalars['ID']>;
  testes?: InputMaybe<Scalars['ID']>;
  time: Scalars['String'];
  transponder?: InputMaybe<Scalars['String']>;
  visit: Scalars['ID'];
  weight?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateFormVersionArgs = {
  fields: Array<ScoreFieldInput>;
  title: Scalars['String'];
};


export type MutationCreateInitialCapturesArgs = {
  amount: Scalars['Int'];
  capture: CaptureInput;
};


export type MutationCreateProjectArgs = {
  authorization?: InputMaybe<Scalars['String']>;
  form: Scalars['ID'];
  involved_persons?: InputMaybe<Array<Scalars['ID']>>;
  manager: Scalars['ID'];
  number: Scalars['String'];
  title: Scalars['String'];
};


export type MutationCreateVisitArgs = {
  cloudcover_type?: InputMaybe<Scalars['ID']>;
  date_end?: InputMaybe<Scalars['Date']>;
  date_start: Scalars['Date'];
  fog_type?: InputMaybe<Scalars['ID']>;
  locations: Array<Scalars['ID']>;
  nets?: InputMaybe<Array<NetInput>>;
  project: Scalars['ID'];
  rain_type?: InputMaybe<Scalars['ID']>;
  temperature_end?: InputMaybe<Scalars['Float']>;
  temperature_start?: InputMaybe<Scalars['Float']>;
  time_end?: InputMaybe<Scalars['String']>;
  time_start?: InputMaybe<Scalars['String']>;
  wind_direction_type?: InputMaybe<Scalars['ID']>;
  windforce?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteCaptureArgs = {
  capture: Scalars['ID'];
};


export type MutationDeleteFormVersionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationArgs = {
  location: Scalars['ID'];
};


export type MutationDeleteNetArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteObservationArgs = {
  observation: Scalars['ID'];
};


export type MutationDeleteProjectArgs = {
  project: Scalars['ID'];
};


export type MutationDeleteVisitArgs = {
  visit: Scalars['ID'];
};


export type MutationEditFormVersionArgs = {
  fields: Array<ScoreFieldInput>;
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationEditProjectArgs = {
  form: Scalars['ID'];
  involved_persons?: InputMaybe<Array<Scalars['ID']>>;
  manager: Scalars['ID'];
  project: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationEditVisitArgs = {
  cloudcover_type?: InputMaybe<Scalars['ID']>;
  date_end?: InputMaybe<Scalars['Date']>;
  date_start: Scalars['Date'];
  fog_type?: InputMaybe<Scalars['ID']>;
  locations: Array<Scalars['ID']>;
  rain_type?: InputMaybe<Scalars['ID']>;
  temperature_end?: InputMaybe<Scalars['Float']>;
  temperature_start?: InputMaybe<Scalars['Float']>;
  time_end?: InputMaybe<Scalars['String']>;
  time_start?: InputMaybe<Scalars['String']>;
  visit: Scalars['ID'];
  wind_direction_type?: InputMaybe<Scalars['ID']>;
  windforce?: InputMaybe<Scalars['Int']>;
};


export type MutationEnableTwoFactorArgs = {
  otp: Scalars['String'];
};


export type MutationEndVisitArgs = {
  date_end?: InputMaybe<Scalars['Date']>;
  temperature_end?: InputMaybe<Scalars['Float']>;
  time_end?: InputMaybe<Scalars['String']>;
  visit: Scalars['ID'];
};


export type MutationLoginArgs = {
  email: Scalars['Email'];
  password: Scalars['String'];
  two_factor_code?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterArgs = {
  email: Scalars['Email'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['Email'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['Email'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSaveCapturesTableArgs = {
  captures: Array<CaptureInput>;
};


export type MutationSubmitFormArgs = {
  form_data: Scalars['String'];
  form_id: Scalars['ID'];
  g_recaptcha_response?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCaptureForVisitArgs = {
  age?: InputMaybe<Scalars['ID']>;
  bat?: InputMaybe<Scalars['String']>;
  bat_sex?: InputMaybe<Scalars['Int']>;
  bold_molt?: InputMaybe<Scalars['ID']>;
  buccalglands?: InputMaybe<Scalars['ID']>;
  capture: Scalars['ID'];
  chinspot?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  count_parasite?: InputMaybe<Scalars['Int']>;
  count_spint?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  dental_plaque?: InputMaybe<Scalars['ID']>;
  dental_wear?: InputMaybe<Scalars['ID']>;
  direction?: InputMaybe<Scalars['String']>;
  epi?: InputMaybe<Scalars['ID']>;
  epididymis_fill?: InputMaybe<Scalars['ID']>;
  epididymis_size?: InputMaybe<Scalars['ID']>;
  fifthfinger?: InputMaybe<Scalars['Float']>;
  forearm_length?: InputMaybe<Scalars['Float']>;
  has_escaped: Scalars['Boolean'];
  location: Scalars['ID'];
  mammaryglands?: InputMaybe<Scalars['ID']>;
  net?: InputMaybe<Scalars['ID']>;
  nipple_bold?: InputMaybe<Scalars['ID']>;
  photo?: InputMaybe<Scalars['Upload']>;
  ring?: InputMaybe<Scalars['String']>;
  sexualstatus?: InputMaybe<Scalars['ID']>;
  species: Scalars['ID'];
  tag?: InputMaybe<Scalars['String']>;
  teat_hair?: InputMaybe<Scalars['ID']>;
  teat_size?: InputMaybe<Scalars['ID']>;
  testes?: InputMaybe<Scalars['ID']>;
  time: Scalars['String'];
  transponder?: InputMaybe<Scalars['String']>;
  visit: Scalars['ID'];
  weight?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdateOrCreateLocationArgs = {
  biotope?: InputMaybe<Scalars['ID']>;
  geom?: InputMaybe<Scalars['MapCoordinate']>;
  location?: InputMaybe<Scalars['ID']>;
  project?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};


export type MutationUpdateOrCreateNetArgs = {
  net_data: NetInput;
  visit: Scalars['ID'];
};


export type MutationUpdateOrCreateObservationArgs = {
  accuracy?: InputMaybe<Scalars['Int']>;
  activity?: InputMaybe<Scalars['ID']>;
  biotope?: InputMaybe<Scalars['ID']>;
  capture: Scalars['ID'];
  date_end?: InputMaybe<Scalars['Date']>;
  date_start: Scalars['Date'];
  geom?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  observation?: InputMaybe<Scalars['ID']>;
  photo?: InputMaybe<Scalars['Upload']>;
  project?: InputMaybe<Scalars['ID']>;
  roost?: InputMaybe<Scalars['ID']>;
  time_end?: InputMaybe<Scalars['String']>;
  time_start: Scalars['String'];
};


export type MutationVerifyCaptureArgs = {
  capture: Scalars['ID'];
  verified: Scalars['Boolean'];
};

export type Net = {
  __typename?: 'Net';
  capabilities: Array<Capability>;
  created_at: Scalars['DateTime'];
  height_max?: Maybe<Scalars['Float']>;
  height_min?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  length?: Maybe<Scalars['Float']>;
  location?: Maybe<Location>;
  lure?: Maybe<Scalars['String']>;
  method?: Maybe<MethodValue>;
  setup?: Maybe<SetupValue>;
  title: Scalars['String'];
  visit?: Maybe<Visit>;
};

export type NetInput = {
  height_max?: InputMaybe<Scalars['Float']>;
  height_min?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  length?: InputMaybe<Scalars['Float']>;
  location_id: Scalars['ID'];
  lure?: InputMaybe<Scalars['Boolean']>;
  method_id?: InputMaybe<Scalars['ID']>;
  setup_id?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export type Observation = {
  __typename?: 'Observation';
  accuracy?: Maybe<Scalars['Int']>;
  activity?: Maybe<ActivityValue>;
  biotope?: Maybe<BiotopeValue>;
  capabilities: Array<Capability>;
  capture: Capture;
  created_at: Scalars['DateTime'];
  end?: Maybe<Scalars['String']>;
  geom?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  images: Array<Scalars['PrivateFile']>;
  observer?: Maybe<Person>;
  project: Project;
  roost?: Maybe<RoostValue>;
  start?: Maybe<Scalars['String']>;
};

export type Page = {
  __typename?: 'Page';
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  active_image?: Maybe<Scalars['Image']>;
  children?: Maybe<Array<Maybe<Page>>>;
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  images: Array<Scalars['Image']>;
  parent?: Maybe<Page>;
  seo?: Maybe<Seo>;
  slug: Scalars['String'];
  template?: Maybe<Template>;
  template_name: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};


export type PageActive_ImageArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};


export type PageImagesArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};

export type Person = {
  __typename?: 'Person';
  email: Scalars['Email'];
  first_name: Scalars['String'];
  id: Scalars['Int'];
  last_name: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type Project = {
  __typename?: 'Project';
  capabilities: Array<Capability>;
  captures_count: Scalars['Int'];
  completed?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['DateTime'];
  form: FormVersion;
  id: Scalars['Int'];
  involved: Array<Person>;
  last_visit?: Maybe<Visit>;
  manager: Person;
  title: Scalars['String'];
  visits: Array<Visit>;
};

export type Query = {
  __typename?: 'Query';
  activityTypes: Array<ActivityValue>;
  biotopeTypes: Array<BiotopeValue>;
  captures: Array<Capture>;
  categories: Array<Category>;
  cloudcoverTypes: Array<CloudcoverValue>;
  currentTenantInfo?: Maybe<Tenant_3af8041b6556776eda1312e7c8acaed7>;
  directionTypes: Array<DirectionValue>;
  fogTypes: Array<FogValue>;
  form?: Maybe<Form>;
  formVersion: FormVersion;
  formVersions: Array<FormVersion>;
  locations: Array<Location>;
  me?: Maybe<User_07e75d37dfdb1fad1b23e74888c041b4>;
  menu?: Maybe<Menu>;
  menus?: Maybe<Array<Maybe<Menu>>>;
  methodTypes: Array<MethodValue>;
  netsPerVisit: Array<Net>;
  observation: Observation;
  observations: Array<Observation>;
  page?: Maybe<Page>;
  persons: Array<Person>;
  project?: Maybe<Project>;
  projects: Array<Project>;
  rainfallTypes: Array<RainfallValue>;
  roostTypes: Array<RoostValue>;
  settings: Array<Setting>;
  setupTypes: Array<SetupValue>;
  speciesTypes: Array<SpeciesValue>;
  visit: Visit;
  visits: Array<Visit>;
};


export type QueryCapturesArgs = {
  project: Scalars['ID'];
};


export type QueryCategoriesArgs = {
  hierarchy?: InputMaybe<Scalars['Boolean']>;
  resource_id?: InputMaybe<Scalars['ID']>;
};


export type QueryFormArgs = {
  id: Scalars['ID'];
};


export type QueryFormVersionArgs = {
  id: Scalars['ID'];
};


export type QueryLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Scalars['ID']>;
};


export type QueryMenuArgs = {
  name: Scalars['String'];
};


export type QueryMenusArgs = {
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNetsPerVisitArgs = {
  location?: InputMaybe<Scalars['ID']>;
  visit: Scalars['ID'];
};


export type QueryObservationArgs = {
  id: Scalars['ID'];
};


export type QueryObservationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPageArgs = {
  segments?: InputMaybe<Scalars['String']>;
};


export type QueryProjectArgs = {
  id: Scalars['ID'];
};


export type QueryProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryVisitArgs = {
  id: Scalars['ID'];
};


export type QueryVisitsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type RainfallValue = {
  __typename?: 'RainfallValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['Int'];
  label: Scalars['String'];
  name: Scalars['String'];
};

export type RoostValue = {
  __typename?: 'RoostValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type ScoreField = {
  __typename?: 'ScoreField';
  category: Scalars['String'];
  field_name: Scalars['String'];
  field_values: Array<ScoreFieldValue>;
  form: FormVersion;
  id: Scalars['Int'];
  source?: Maybe<Scalars['String']>;
};

export type ScoreFieldInput = {
  category: Scalars['String'];
  field_name: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  values: Array<ScoreFieldValueInput>;
};

export type ScoreFieldValue = {
  __typename?: 'ScoreFieldValue';
  definition?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  score_field_id: Scalars['Int'];
  score_value: Scalars['String'];
};

export type ScoreFieldValueInput = {
  definition?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  score_value: Scalars['String'];
};

export type Seo = {
  __typename?: 'Seo';
  meta_description?: Maybe<Scalars['String']>;
  meta_follow?: Maybe<Scalars['Boolean']>;
  meta_index?: Maybe<Scalars['Boolean']>;
  meta_title?: Maybe<Scalars['String']>;
};

export type Setting = {
  __typename?: 'Setting';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Mixed']>;
};

export type Setup = {
  __typename?: 'Setup';
  geom?: Maybe<Scalars['MapCoordinate']>;
  id?: Maybe<Scalars['ID']>;
};

export type SetupValue = {
  __typename?: 'SetupValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type SpeciesValue = {
  __typename?: 'SpeciesValue';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Template = TemplateStandaard;

export type TemplateStandaard = {
  __typename?: 'TemplateStandaard';
  capabilities: Array<Capability>;
  created_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  published: Scalars['Boolean'];
  tekst?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  active_image?: Maybe<Scalars['Image']>;
  capabilities: Array<Capability>;
  created_at?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id: Scalars['Int'];
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  images: Array<Scalars['Image']>;
  locales: Array<Scalars['String']>;
  published: Scalars['Boolean'];
  seo?: Maybe<Seo>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};


export type TenantActive_ImageArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};


export type TenantImagesArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};

export type Tenant_3af8041b6556776eda1312e7c8acaed7 = {
  __typename?: 'Tenant_3af8041b6556776eda1312e7c8acaed7';
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  active_image?: Maybe<Scalars['Image']>;
  seo?: Maybe<Seo>;
  title: Scalars['String'];
};


export type Tenant_3af8041b6556776eda1312e7c8acaed7Active_ImageArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};

export type TwoFactorSecret = {
  __typename?: 'TwoFactorSecret';
  app: Scalars['String'];
  email: Scalars['Email'];
  secret: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  _?: Maybe<Scalars['String']>;
};

export type User_07e75d37dfdb1fad1b23e74888c041b4 = {
  __typename?: 'User_07e75d37dfdb1fad1b23e74888c041b4';
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  active_image?: Maybe<Scalars['Image']>;
  avatar: Scalars['String'];
  capabilities: Array<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  email: Scalars['Email'];
  first_name: Scalars['String'];
  /** Check Glide docs for argument options: https://glide.thephpleague.com/1.0/api/quick-reference/ */
  images: Array<Scalars['Image']>;
  last_name: Scalars['String'];
  name: Scalars['String'];
  published: Scalars['Boolean'];
  role?: Maybe<Role>;
  role_id: Scalars['ID'];
  tenants: Array<Tenant>;
  tenants_count?: Maybe<Scalars['Int']>;
  two_factor_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  uuid: Scalars['Uuid'];
};


export type User_07e75d37dfdb1fad1b23e74888c041b4Active_ImageArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};


export type User_07e75d37dfdb1fad1b23e74888c041b4AvatarArgs = {
  w?: InputMaybe<Scalars['Int']>;
};


export type User_07e75d37dfdb1fad1b23e74888c041b4ImagesArgs = {
  blur?: InputMaybe<Scalars['Int']>;
  bri?: InputMaybe<Scalars['Int']>;
  dpr?: InputMaybe<Scalars['Int']>;
  fit?: InputMaybe<Scalars['String']>;
  fm?: InputMaybe<Scalars['String']>;
  h?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['Int']>;
  w?: InputMaybe<Scalars['Int']>;
};

export type Visit = {
  __typename?: 'Visit';
  capabilities: Array<Capability>;
  captures: Array<Capture>;
  captures_count?: Maybe<Scalars['Int']>;
  cloud_cover_type?: Maybe<CloudcoverValue>;
  created_at: Scalars['DateTime'];
  end?: Maybe<Scalars['DateTime']>;
  fog_type?: Maybe<FogValue>;
  id: Scalars['Int'];
  locations: Array<Location>;
  nets: Array<Net>;
  observer?: Maybe<Person>;
  project: Project;
  rainfall_type?: Maybe<RainfallValue>;
  start: Scalars['DateTime'];
  temperature_end?: Maybe<Scalars['Float']>;
  temperature_start?: Maybe<Scalars['Float']>;
  verified: Scalars['Boolean'];
  wind_direction_type?: Maybe<DirectionValue>;
  wind_force?: Maybe<Scalars['Int']>;
};

export type AcceptInviteMutationVariables = Exact<{
  email: Scalars['Email'];
  invite: Scalars['String'];
  password: Scalars['String'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite?: boolean | null };

export type RegisterMutationVariables = Exact<{
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  email: Scalars['Email'];
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: null | null };

export type CreateCaptureForVisitMutationVariables = Exact<{
  visit: Scalars['ID'];
  location: Scalars['ID'];
  net?: InputMaybe<Scalars['ID']>;
  species: Scalars['ID'];
  bat?: InputMaybe<Scalars['String']>;
  has_escaped: Scalars['Boolean'];
  direction?: InputMaybe<Scalars['String']>;
  chinspot?: InputMaybe<Scalars['ID']>;
  epi?: InputMaybe<Scalars['ID']>;
  bat_sex?: InputMaybe<Scalars['Int']>;
  forearm_length?: InputMaybe<Scalars['Float']>;
  fifthfinger?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
  bold_molt?: InputMaybe<Scalars['ID']>;
  dental_wear?: InputMaybe<Scalars['ID']>;
  dental_plaque?: InputMaybe<Scalars['ID']>;
  buccalglands?: InputMaybe<Scalars['ID']>;
  age?: InputMaybe<Scalars['ID']>;
  testes?: InputMaybe<Scalars['ID']>;
  epididymis_size?: InputMaybe<Scalars['ID']>;
  epididymis_fill?: InputMaybe<Scalars['ID']>;
  sexualstatus?: InputMaybe<Scalars['ID']>;
  mammaryglands?: InputMaybe<Scalars['ID']>;
  nipple_bold?: InputMaybe<Scalars['ID']>;
  teat_size?: InputMaybe<Scalars['ID']>;
  teat_hair?: InputMaybe<Scalars['ID']>;
  count_spint?: InputMaybe<Scalars['Int']>;
  count_parasite?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  ring?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  transponder?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  time: Scalars['String'];
}>;


export type CreateCaptureForVisitMutation = { __typename?: 'Mutation', createCaptureForVisit: { __typename?: 'Capture', id: number, created_at: string } };

export type CreateInitialCapturesMutationVariables = Exact<{
  capture: CaptureInput;
  amount: Scalars['Int'];
}>;


export type CreateInitialCapturesMutation = { __typename?: 'Mutation', createInitialCaptures?: { __typename?: 'Capture', id: number, date?: string | null, time?: string | null, species: { __typename?: 'SpeciesValue', id: number, title: string } } | null };

export type DeleteCaptureMutationVariables = Exact<{
  capture: Scalars['ID'];
}>;


export type DeleteCaptureMutation = { __typename?: 'Mutation', deleteCapture?: null | null };

export type SaveCapturesTableMutationVariables = Exact<{
  captures: Array<CaptureInput> | CaptureInput;
}>;


export type SaveCapturesTableMutation = { __typename?: 'Mutation', saveCapturesTable?: null | null };

export type UpdateCaptureForVisitMutationVariables = Exact<{
  capture: Scalars['ID'];
  visit: Scalars['ID'];
  location: Scalars['ID'];
  net?: InputMaybe<Scalars['ID']>;
  species: Scalars['ID'];
  bat?: InputMaybe<Scalars['String']>;
  has_escaped: Scalars['Boolean'];
  direction?: InputMaybe<Scalars['String']>;
  chinspot?: InputMaybe<Scalars['ID']>;
  epi?: InputMaybe<Scalars['ID']>;
  bat_sex?: InputMaybe<Scalars['Int']>;
  forearm_length?: InputMaybe<Scalars['Float']>;
  fifthfinger?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
  bold_molt?: InputMaybe<Scalars['ID']>;
  dental_wear?: InputMaybe<Scalars['ID']>;
  dental_plaque?: InputMaybe<Scalars['ID']>;
  buccalglands?: InputMaybe<Scalars['ID']>;
  age?: InputMaybe<Scalars['ID']>;
  testes?: InputMaybe<Scalars['ID']>;
  epididymis_size?: InputMaybe<Scalars['ID']>;
  epididymis_fill?: InputMaybe<Scalars['ID']>;
  sexualstatus?: InputMaybe<Scalars['ID']>;
  mammaryglands?: InputMaybe<Scalars['ID']>;
  nipple_bold?: InputMaybe<Scalars['ID']>;
  teat_size?: InputMaybe<Scalars['ID']>;
  teat_hair?: InputMaybe<Scalars['ID']>;
  count_spint?: InputMaybe<Scalars['Int']>;
  count_parasite?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  ring?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  transponder?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['Upload']>;
  date: Scalars['Date'];
  time: Scalars['String'];
}>;


export type UpdateCaptureForVisitMutation = { __typename?: 'Mutation', updateCaptureForVisit: { __typename?: 'Capture', id: number, created_at: string } };

export type VerifyCaptureMutationVariables = Exact<{
  capture: Scalars['ID'];
  verified: Scalars['Boolean'];
}>;


export type VerifyCaptureMutation = { __typename?: 'Mutation', verifyCapture: { __typename?: 'Capture', verified?: boolean | null } };

export type CreateFormVersionMutationVariables = Exact<{
  title: Scalars['String'];
  fields: Array<ScoreFieldInput> | ScoreFieldInput;
}>;


export type CreateFormVersionMutation = { __typename?: 'Mutation', createFormVersion: { __typename?: 'FormVersion', id: number } };

export type DeleteFormVersionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFormVersionMutation = { __typename?: 'Mutation', deleteFormVersion?: null | null };

export type EditFormVersionMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  fields: Array<ScoreFieldInput> | ScoreFieldInput;
}>;


export type EditFormVersionMutation = { __typename?: 'Mutation', editFormVersion?: null | null };

export type DeleteLocationMutationVariables = Exact<{
  location: Scalars['ID'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation?: null | null };

export type UpdateOrCreateLocationMutationVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  biotope?: InputMaybe<Scalars['ID']>;
  geom?: InputMaybe<Scalars['MapCoordinate']>;
  project?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateOrCreateLocationMutation = { __typename?: 'Mutation', updateOrCreateLocation: { __typename?: 'Location', id: number } };

export type DeleteNetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNetMutation = { __typename?: 'Mutation', deleteNet: boolean };

export type UpdateOrCreateNetMutationVariables = Exact<{
  visit: Scalars['ID'];
  net_data: NetInput;
}>;


export type UpdateOrCreateNetMutation = { __typename?: 'Mutation', updateOrCreateNet: { __typename?: 'Net', id: number } };

export type DeleteObservationMutationVariables = Exact<{
  observation: Scalars['ID'];
}>;


export type DeleteObservationMutation = { __typename?: 'Mutation', deleteObservation?: null | null };

export type UpdateOrCreateObservationMutationVariables = Exact<{
  observation?: InputMaybe<Scalars['ID']>;
  capture: Scalars['ID'];
  date_start: Scalars['Date'];
  time_start: Scalars['String'];
  date_end?: InputMaybe<Scalars['Date']>;
  time_end?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Array<InputMaybe<Scalars['Float']>> | InputMaybe<Scalars['Float']>>;
  activity?: InputMaybe<Scalars['ID']>;
  biotope?: InputMaybe<Scalars['ID']>;
  roost?: InputMaybe<Scalars['ID']>;
  accuracy?: InputMaybe<Scalars['Int']>;
  project: Scalars['ID'];
  photo?: InputMaybe<Scalars['Upload']>;
}>;


export type UpdateOrCreateObservationMutation = { __typename?: 'Mutation', updateOrCreateObservation: { __typename?: 'Observation', id: number } };

export type CreateProjectMutationVariables = Exact<{
  form: Scalars['ID'];
  involved_persons?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  manager: Scalars['ID'];
  number: Scalars['String'];
  title: Scalars['String'];
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: number } };

export type DeleteProjectMutationVariables = Exact<{
  project: Scalars['ID'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject?: null | null };

export type EditProjectMutationVariables = Exact<{
  project: Scalars['ID'];
  form: Scalars['ID'];
  involved_persons?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  manager: Scalars['ID'];
  title: Scalars['String'];
}>;


export type EditProjectMutation = { __typename?: 'Mutation', editProject?: null | null };

export type CreateVisitMutationVariables = Exact<{
  date_start: Scalars['Date'];
  locations: Array<Scalars['ID']> | Scalars['ID'];
  project: Scalars['ID'];
  time_start?: InputMaybe<Scalars['String']>;
  cloudcover_type?: InputMaybe<Scalars['ID']>;
  fog_type?: InputMaybe<Scalars['ID']>;
  rain_type?: InputMaybe<Scalars['ID']>;
  temperature_start?: InputMaybe<Scalars['Float']>;
  wind_direction_type?: InputMaybe<Scalars['ID']>;
  windforce?: InputMaybe<Scalars['Int']>;
  date_end?: InputMaybe<Scalars['Date']>;
  time_end?: InputMaybe<Scalars['String']>;
  temperature_end?: InputMaybe<Scalars['Float']>;
  nets?: InputMaybe<Array<NetInput> | NetInput>;
}>;


export type CreateVisitMutation = { __typename?: 'Mutation', createVisit: { __typename?: 'Visit', id: number } };

export type DeleteVisitMutationVariables = Exact<{
  visit: Scalars['ID'];
}>;


export type DeleteVisitMutation = { __typename?: 'Mutation', deleteVisit?: null | null };

export type EditVisitMutationVariables = Exact<{
  visit: Scalars['ID'];
  date_start: Scalars['Date'];
  locations: Array<Scalars['ID']> | Scalars['ID'];
  time_start?: InputMaybe<Scalars['String']>;
  cloudcover_type?: InputMaybe<Scalars['ID']>;
  fog_type?: InputMaybe<Scalars['ID']>;
  rain_type?: InputMaybe<Scalars['ID']>;
  temperature_start?: InputMaybe<Scalars['Float']>;
  wind_direction_type?: InputMaybe<Scalars['ID']>;
  windforce?: InputMaybe<Scalars['Int']>;
  date_end?: InputMaybe<Scalars['Date']>;
  time_end?: InputMaybe<Scalars['String']>;
  temperature_end?: InputMaybe<Scalars['Float']>;
}>;


export type EditVisitMutation = { __typename?: 'Mutation', editVisit?: null | null };

export type EndVisitMutationVariables = Exact<{
  visit: Scalars['ID'];
  date_end?: InputMaybe<Scalars['Date']>;
  time_end?: InputMaybe<Scalars['String']>;
  temperature_end?: InputMaybe<Scalars['Float']>;
}>;


export type EndVisitMutation = { __typename?: 'Mutation', endVisit: { __typename?: 'Visit', id: number } };

export type DashboardQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type DashboardQuery = { __typename?: 'Query', lastObservations: Array<{ __typename?: 'Observation', id: number, start?: string | null, capture: { __typename?: 'Capture', bat?: string | null } }>, lastVisits: Array<{ __typename?: 'Visit', id: number, start: string, captures_count?: number | null, verified: boolean, observer?: { __typename?: 'Person', id: number, name: string } | null, project: { __typename?: 'Project', id: number, title: string } }>, lastProjects: Array<{ __typename?: 'Project', id: number, created_at: string, title: string, captures_count: number, last_visit?: { __typename?: 'Visit', start: string, verified: boolean } | null }> };

export type SpeciesTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpeciesTypesQuery = { __typename?: 'Query', speciesTypes: Array<{ __typename?: 'SpeciesValue', id: number, title: string }> };

export type FormVersionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FormVersionQuery = { __typename?: 'Query', formVersion: { __typename?: 'FormVersion', id: number, title: string, projects_count: number, score_fields: Array<{ __typename?: 'ScoreField', id: number, category: string, field_name: string, field_values: Array<{ __typename?: 'ScoreFieldValue', id: number, score_value: string, definition?: string | null }> }>, capabilities: Array<{ __typename?: 'Capability', name: string }> } };

export type FormVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FormVersionsQuery = { __typename?: 'Query', formVersions: Array<{ __typename?: 'FormVersion', id: number, title: string, capabilities: Array<{ __typename?: 'Capability', name: string }> }> };

export type LocationsQueryVariables = Exact<{
  project?: InputMaybe<Scalars['ID']>;
}>;


export type LocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: number, title: string, biotope?: { __typename?: 'BiotopeValue', id: number, title: string } | null, setup?: { __typename?: 'Setup', id?: string | null, geom?: any | null } | null, capabilities: Array<{ __typename?: 'Capability', name: string }> }> };

export type LocationOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationOptionsQuery = { __typename?: 'Query', setupTypes: Array<{ __typename?: 'SetupValue', id: number, title: string }>, methodTypes: Array<{ __typename?: 'MethodValue', id: number, title: string }>, biotopeTypes: Array<{ __typename?: 'BiotopeValue', id: number, title: string }> };

export type NetsPerVisitQueryVariables = Exact<{
  visit: Scalars['ID'];
  location?: InputMaybe<Scalars['ID']>;
}>;


export type NetsPerVisitQuery = { __typename?: 'Query', netsPerVisit: Array<{ __typename?: 'Net', id: number, title: string, lure?: string | null, length?: number | null, height_min?: number | null, height_max?: number | null, method?: { __typename?: 'MethodValue', id: number } | null, setup?: { __typename?: 'SetupValue', id: number } | null, capabilities: Array<{ __typename?: 'Capability', name: string }> }> };

export type CapturesQueryVariables = Exact<{
  project: Scalars['ID'];
}>;


export type CapturesQuery = { __typename?: 'Query', captures: Array<{ __typename?: 'Capture', id: number, title?: string | null }> };

export type ObservationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ObservationQuery = { __typename?: 'Query', observation: { __typename?: 'Observation', id: number, start?: string | null, end?: string | null, geom?: string | null, images: Array<any>, capture: { __typename?: 'Capture', bat?: string | null }, observer?: { __typename?: 'Person', id: number, name: string } | null } };

export type ObservationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ObservationsQuery = { __typename?: 'Query', observations: Array<{ __typename?: 'Observation', id: number, start?: string | null, geom?: string | null, accuracy?: number | null, end?: string | null, images: Array<any>, capture: { __typename?: 'Capture', id: number, bat?: string | null }, capabilities: Array<{ __typename?: 'Capability', name: string }>, project: { __typename?: 'Project', id: number }, observer?: { __typename?: 'Person', id: number, name: string } | null, roost?: { __typename?: 'RoostValue', id: number } | null, activity?: { __typename?: 'ActivityValue', id: number } | null, biotope?: { __typename?: 'BiotopeValue', id: number } | null }> };

export type ObservationOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ObservationOptionsQuery = { __typename?: 'Query', biotopeTypes: Array<{ __typename?: 'BiotopeValue', id: number, title: string }>, activityTypes: Array<{ __typename?: 'ActivityValue', id: number, title: string }>, roostTypes: Array<{ __typename?: 'RoostValue', id: number, title: string }> };

export type PageQueryVariables = Exact<{
  segments: Scalars['String'];
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', active_image?: Image | null, slug: string, title: string, url: string, seo?: { __typename?: 'Seo', meta_title?: string | null, meta_description?: string | null, meta_index?: boolean | null, meta_follow?: boolean | null } | null } | null };

export type ProjectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectOptionsQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: number, name: string }>, formVersions: Array<{ __typename?: 'FormVersion', id: number, title: string }> };

export type ProjectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, title: string, created_at: string, captures_count: number, form: { __typename?: 'FormVersion', id: number }, capabilities: Array<{ __typename?: 'Capability', name: string }>, involved: Array<{ __typename?: 'Person', id: number, name: string }>, manager: { __typename?: 'Person', id: number, name: string }, visits: Array<{ __typename?: 'Visit', id: number, start: string, captures_count?: number | null, temperature_start?: number | null, verified: boolean, observer?: { __typename?: 'Person', id: number, name: string } | null, cloud_cover_type?: { __typename?: 'CloudcoverValue', id: number, title: string } | null, fog_type?: { __typename?: 'FogValue', id: number, title: string } | null, rainfall_type?: { __typename?: 'RainfallValue', id: number, title: string } | null, wind_direction_type?: { __typename?: 'DirectionValue', id: number, title: string } | null, locations: Array<{ __typename?: 'Location', id: number, title: string }>, captures: Array<{ __typename?: 'Capture', id: number, bat?: string | null, verified?: boolean | null, date?: string | null, time?: string | null, species: { __typename?: 'SpeciesValue', id: number, title: string } }> }> } | null };

export type ProjectsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type ProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: number, title: string, captures_count: number, capabilities: Array<{ __typename?: 'Capability', name: string }>, involved: Array<{ __typename?: 'Person', id: number, name: string }>, last_visit?: { __typename?: 'Visit', end?: string | null, start: string, verified: boolean } | null }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User_07e75d37dfdb1fad1b23e74888c041b4', uuid: string, first_name: string, name: string, email: string, capabilities: Array<string> } | null };

export type VisitOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type VisitOptionsQuery = { __typename?: 'Query', cloudcoverTypes: Array<{ __typename?: 'CloudcoverValue', id: number, title: string }>, directionTypes: Array<{ __typename?: 'DirectionValue', id: number, title: string }>, rainfallTypes: Array<{ __typename?: 'RainfallValue', id: number, title: string }>, fogTypes: Array<{ __typename?: 'FogValue', id: number, title: string }> };

export type VisitQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VisitQuery = { __typename?: 'Query', visit: { __typename?: 'Visit', id: number, start: string, end?: string | null, temperature_start?: number | null, temperature_end?: number | null, wind_force?: number | null, capabilities: Array<{ __typename?: 'Capability', name: string }>, cloud_cover_type?: { __typename?: 'CloudcoverValue', id: number, title: string } | null, fog_type?: { __typename?: 'FogValue', id: number, title: string } | null, rainfall_type?: { __typename?: 'RainfallValue', id: number, title: string } | null, wind_direction_type?: { __typename?: 'DirectionValue', id: number, title: string } | null, locations: Array<{ __typename?: 'Location', id: number, title: string }>, nets: Array<{ __typename?: 'Net', id: number, title: string }>, captures: Array<{ __typename?: 'Capture', id: number, direction?: string | null, has_escaped?: boolean | null, bat_sex?: number | null, bat?: string | null, forearm_length?: number | null, fifthfinger?: number | null, weight?: number | null, count_spint?: number | null, count_parasite?: number | null, comment?: string | null, chinspot?: number | null, epi?: number | null, bold_molt?: number | null, dental_wear?: number | null, dental_plaque?: number | null, buccalglands?: number | null, age?: number | null, testes?: number | null, nipple_bold?: number | null, epididymis_size?: number | null, epididymis_fill?: number | null, sexualstatus?: number | null, mammaryglands?: number | null, teat_size?: number | null, teat_hair?: number | null, date?: string | null, time?: string | null, verified?: boolean | null, photo?: any | null, tag?: string | null, transponder?: string | null, ring?: string | null, observations?: Array<{ __typename?: 'Observation', id: number } | null> | null, capabilities: Array<{ __typename?: 'Capability', name: string }>, species: { __typename?: 'SpeciesValue', id: number, title: string }, location?: { __typename?: 'Location', id: number } | null, net?: { __typename?: 'Net', id: number } | null }>, project: { __typename?: 'Project', id: number, title: string, form: { __typename?: 'FormVersion', id: number, score_fields: Array<{ __typename?: 'ScoreField', id: number, field_name: string, source?: string | null, category: string, field_values: Array<{ __typename?: 'ScoreFieldValue', id: number, score_value: string, definition?: string | null }> }> } } } };

export type VisitsQueryVariables = Exact<{ [key: string]: never; }>;


export type VisitsQuery = { __typename?: 'Query', visits: Array<{ __typename?: 'Visit', id: number, captures_count?: number | null, start: string, temperature_end?: number | null, temperature_start?: number | null, verified: boolean, wind_force?: number | null, capabilities: Array<{ __typename?: 'Capability', name: string }>, captures: Array<{ __typename?: 'Capture', id: number, bat?: string | null, verified?: boolean | null, date?: string | null, time?: string | null, species: { __typename?: 'SpeciesValue', id: number, title: string } }>, cloud_cover_type?: { __typename?: 'CloudcoverValue', id: number, title: string } | null, fog_type?: { __typename?: 'FogValue', id: number, title: string } | null, locations: Array<{ __typename?: 'Location', id: number, title: string }>, observer?: { __typename?: 'Person', id: number, name: string } | null, project: { __typename?: 'Project', id: number, title: string, involved: Array<{ __typename?: 'Person', name: string }> }, rainfall_type?: { __typename?: 'RainfallValue', id: number, title: string } | null, wind_direction_type?: { __typename?: 'DirectionValue', id: number, title: string } | null }> };


export const AcceptInviteDocument = gql`
    mutation acceptInvite($email: Email!, $invite: String!, $password: String!) {
  acceptInvite(email: $email, invite: $invite, password: $password)
}
    `;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptInviteMutation({
 *   variables: {
 *     email: // value for 'email'
 *     invite: // value for 'invite'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useAcceptInviteMutation(options: VueApolloComposable.UseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
}
export type AcceptInviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const RegisterDocument = gql`
    mutation register($first_name: String!, $last_name: String!, $email: Email!) {
  register(first_name: $first_name, last_name: $last_name, email: $email)
}
    `;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterMutation({
 *   variables: {
 *     first_name: // value for 'first_name'
 *     last_name: // value for 'last_name'
 *     email: // value for 'email'
 *   },
 * });
 */
export function useRegisterMutation(options: VueApolloComposable.UseMutationOptions<RegisterMutation, RegisterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegisterMutation, RegisterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
}
export type RegisterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegisterMutation, RegisterMutationVariables>;
export const CreateCaptureForVisitDocument = gql`
    mutation createCaptureForVisit($visit: ID!, $location: ID!, $net: ID, $species: ID!, $bat: String, $has_escaped: Boolean!, $direction: String, $chinspot: ID, $epi: ID, $bat_sex: Int, $forearm_length: Float, $fifthfinger: Float, $weight: Float, $bold_molt: ID, $dental_wear: ID, $dental_plaque: ID, $buccalglands: ID, $age: ID, $testes: ID, $epididymis_size: ID, $epididymis_fill: ID, $sexualstatus: ID, $mammaryglands: ID, $nipple_bold: ID, $teat_size: ID, $teat_hair: ID, $count_spint: Int, $count_parasite: Int, $comment: String, $ring: String, $tag: String, $transponder: String, $date: Date!, $time: String!) {
  createCaptureForVisit(
    visit: $visit
    location: $location
    net: $net
    species: $species
    bat: $bat
    has_escaped: $has_escaped
    direction: $direction
    chinspot: $chinspot
    epi: $epi
    bat_sex: $bat_sex
    forearm_length: $forearm_length
    fifthfinger: $fifthfinger
    weight: $weight
    bold_molt: $bold_molt
    dental_wear: $dental_wear
    dental_plaque: $dental_plaque
    buccalglands: $buccalglands
    age: $age
    testes: $testes
    epididymis_size: $epididymis_size
    epididymis_fill: $epididymis_fill
    sexualstatus: $sexualstatus
    mammaryglands: $mammaryglands
    nipple_bold: $nipple_bold
    teat_size: $teat_size
    teat_hair: $teat_hair
    count_spint: $count_spint
    count_parasite: $count_parasite
    comment: $comment
    ring: $ring
    tag: $tag
    transponder: $transponder
    date: $date
    time: $time
  ) {
    id
    created_at
  }
}
    `;

/**
 * __useCreateCaptureForVisitMutation__
 *
 * To run a mutation, you first call `useCreateCaptureForVisitMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaptureForVisitMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCaptureForVisitMutation({
 *   variables: {
 *     visit: // value for 'visit'
 *     location: // value for 'location'
 *     net: // value for 'net'
 *     species: // value for 'species'
 *     bat: // value for 'bat'
 *     has_escaped: // value for 'has_escaped'
 *     direction: // value for 'direction'
 *     chinspot: // value for 'chinspot'
 *     epi: // value for 'epi'
 *     bat_sex: // value for 'bat_sex'
 *     forearm_length: // value for 'forearm_length'
 *     fifthfinger: // value for 'fifthfinger'
 *     weight: // value for 'weight'
 *     bold_molt: // value for 'bold_molt'
 *     dental_wear: // value for 'dental_wear'
 *     dental_plaque: // value for 'dental_plaque'
 *     buccalglands: // value for 'buccalglands'
 *     age: // value for 'age'
 *     testes: // value for 'testes'
 *     epididymis_size: // value for 'epididymis_size'
 *     epididymis_fill: // value for 'epididymis_fill'
 *     sexualstatus: // value for 'sexualstatus'
 *     mammaryglands: // value for 'mammaryglands'
 *     nipple_bold: // value for 'nipple_bold'
 *     teat_size: // value for 'teat_size'
 *     teat_hair: // value for 'teat_hair'
 *     count_spint: // value for 'count_spint'
 *     count_parasite: // value for 'count_parasite'
 *     comment: // value for 'comment'
 *     ring: // value for 'ring'
 *     tag: // value for 'tag'
 *     transponder: // value for 'transponder'
 *     date: // value for 'date'
 *     time: // value for 'time'
 *   },
 * });
 */
export function useCreateCaptureForVisitMutation(options: VueApolloComposable.UseMutationOptions<CreateCaptureForVisitMutation, CreateCaptureForVisitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCaptureForVisitMutation, CreateCaptureForVisitMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCaptureForVisitMutation, CreateCaptureForVisitMutationVariables>(CreateCaptureForVisitDocument, options);
}
export type CreateCaptureForVisitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCaptureForVisitMutation, CreateCaptureForVisitMutationVariables>;
export const CreateInitialCapturesDocument = gql`
    mutation createInitialCaptures($capture: CaptureInput!, $amount: Int!) {
  createInitialCaptures(capture: $capture, amount: $amount) {
    id
    date
    time
    species {
      id
      title
    }
  }
}
    `;

/**
 * __useCreateInitialCapturesMutation__
 *
 * To run a mutation, you first call `useCreateInitialCapturesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateInitialCapturesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateInitialCapturesMutation({
 *   variables: {
 *     capture: // value for 'capture'
 *     amount: // value for 'amount'
 *   },
 * });
 */
export function useCreateInitialCapturesMutation(options: VueApolloComposable.UseMutationOptions<CreateInitialCapturesMutation, CreateInitialCapturesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateInitialCapturesMutation, CreateInitialCapturesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateInitialCapturesMutation, CreateInitialCapturesMutationVariables>(CreateInitialCapturesDocument, options);
}
export type CreateInitialCapturesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateInitialCapturesMutation, CreateInitialCapturesMutationVariables>;
export const DeleteCaptureDocument = gql`
    mutation deleteCapture($capture: ID!) {
  deleteCapture(capture: $capture)
}
    `;

/**
 * __useDeleteCaptureMutation__
 *
 * To run a mutation, you first call `useDeleteCaptureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaptureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCaptureMutation({
 *   variables: {
 *     capture: // value for 'capture'
 *   },
 * });
 */
export function useDeleteCaptureMutation(options: VueApolloComposable.UseMutationOptions<DeleteCaptureMutation, DeleteCaptureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCaptureMutation, DeleteCaptureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCaptureMutation, DeleteCaptureMutationVariables>(DeleteCaptureDocument, options);
}
export type DeleteCaptureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCaptureMutation, DeleteCaptureMutationVariables>;
export const SaveCapturesTableDocument = gql`
    mutation saveCapturesTable($captures: [CaptureInput!]!) {
  saveCapturesTable(captures: $captures)
}
    `;

/**
 * __useSaveCapturesTableMutation__
 *
 * To run a mutation, you first call `useSaveCapturesTableMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveCapturesTableMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveCapturesTableMutation({
 *   variables: {
 *     captures: // value for 'captures'
 *   },
 * });
 */
export function useSaveCapturesTableMutation(options: VueApolloComposable.UseMutationOptions<SaveCapturesTableMutation, SaveCapturesTableMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveCapturesTableMutation, SaveCapturesTableMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveCapturesTableMutation, SaveCapturesTableMutationVariables>(SaveCapturesTableDocument, options);
}
export type SaveCapturesTableMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveCapturesTableMutation, SaveCapturesTableMutationVariables>;
export const UpdateCaptureForVisitDocument = gql`
    mutation updateCaptureForVisit($capture: ID!, $visit: ID!, $location: ID!, $net: ID, $species: ID!, $bat: String, $has_escaped: Boolean!, $direction: String, $chinspot: ID, $epi: ID, $bat_sex: Int, $forearm_length: Float, $fifthfinger: Float, $weight: Float, $bold_molt: ID, $dental_wear: ID, $dental_plaque: ID, $buccalglands: ID, $age: ID, $testes: ID, $epididymis_size: ID, $epididymis_fill: ID, $sexualstatus: ID, $mammaryglands: ID, $nipple_bold: ID, $teat_size: ID, $teat_hair: ID, $count_spint: Int, $count_parasite: Int, $comment: String, $ring: String, $tag: String, $transponder: String, $photo: Upload, $date: Date!, $time: String!) {
  updateCaptureForVisit(
    capture: $capture
    visit: $visit
    location: $location
    net: $net
    species: $species
    bat: $bat
    has_escaped: $has_escaped
    direction: $direction
    chinspot: $chinspot
    epi: $epi
    bat_sex: $bat_sex
    forearm_length: $forearm_length
    fifthfinger: $fifthfinger
    weight: $weight
    bold_molt: $bold_molt
    dental_wear: $dental_wear
    dental_plaque: $dental_plaque
    buccalglands: $buccalglands
    age: $age
    testes: $testes
    epididymis_size: $epididymis_size
    epididymis_fill: $epididymis_fill
    sexualstatus: $sexualstatus
    mammaryglands: $mammaryglands
    nipple_bold: $nipple_bold
    teat_size: $teat_size
    teat_hair: $teat_hair
    count_spint: $count_spint
    count_parasite: $count_parasite
    comment: $comment
    ring: $ring
    tag: $tag
    transponder: $transponder
    photo: $photo
    date: $date
    time: $time
  ) {
    id
    created_at
  }
}
    `;

/**
 * __useUpdateCaptureForVisitMutation__
 *
 * To run a mutation, you first call `useUpdateCaptureForVisitMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaptureForVisitMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCaptureForVisitMutation({
 *   variables: {
 *     capture: // value for 'capture'
 *     visit: // value for 'visit'
 *     location: // value for 'location'
 *     net: // value for 'net'
 *     species: // value for 'species'
 *     bat: // value for 'bat'
 *     has_escaped: // value for 'has_escaped'
 *     direction: // value for 'direction'
 *     chinspot: // value for 'chinspot'
 *     epi: // value for 'epi'
 *     bat_sex: // value for 'bat_sex'
 *     forearm_length: // value for 'forearm_length'
 *     fifthfinger: // value for 'fifthfinger'
 *     weight: // value for 'weight'
 *     bold_molt: // value for 'bold_molt'
 *     dental_wear: // value for 'dental_wear'
 *     dental_plaque: // value for 'dental_plaque'
 *     buccalglands: // value for 'buccalglands'
 *     age: // value for 'age'
 *     testes: // value for 'testes'
 *     epididymis_size: // value for 'epididymis_size'
 *     epididymis_fill: // value for 'epididymis_fill'
 *     sexualstatus: // value for 'sexualstatus'
 *     mammaryglands: // value for 'mammaryglands'
 *     nipple_bold: // value for 'nipple_bold'
 *     teat_size: // value for 'teat_size'
 *     teat_hair: // value for 'teat_hair'
 *     count_spint: // value for 'count_spint'
 *     count_parasite: // value for 'count_parasite'
 *     comment: // value for 'comment'
 *     ring: // value for 'ring'
 *     tag: // value for 'tag'
 *     transponder: // value for 'transponder'
 *     photo: // value for 'photo'
 *     date: // value for 'date'
 *     time: // value for 'time'
 *   },
 * });
 */
export function useUpdateCaptureForVisitMutation(options: VueApolloComposable.UseMutationOptions<UpdateCaptureForVisitMutation, UpdateCaptureForVisitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCaptureForVisitMutation, UpdateCaptureForVisitMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCaptureForVisitMutation, UpdateCaptureForVisitMutationVariables>(UpdateCaptureForVisitDocument, options);
}
export type UpdateCaptureForVisitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCaptureForVisitMutation, UpdateCaptureForVisitMutationVariables>;
export const VerifyCaptureDocument = gql`
    mutation verifyCapture($capture: ID!, $verified: Boolean!) {
  verifyCapture(capture: $capture, verified: $verified) {
    verified
  }
}
    `;

/**
 * __useVerifyCaptureMutation__
 *
 * To run a mutation, you first call `useVerifyCaptureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCaptureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVerifyCaptureMutation({
 *   variables: {
 *     capture: // value for 'capture'
 *     verified: // value for 'verified'
 *   },
 * });
 */
export function useVerifyCaptureMutation(options: VueApolloComposable.UseMutationOptions<VerifyCaptureMutation, VerifyCaptureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<VerifyCaptureMutation, VerifyCaptureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<VerifyCaptureMutation, VerifyCaptureMutationVariables>(VerifyCaptureDocument, options);
}
export type VerifyCaptureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<VerifyCaptureMutation, VerifyCaptureMutationVariables>;
export const CreateFormVersionDocument = gql`
    mutation createFormVersion($title: String!, $fields: [ScoreFieldInput!]!) {
  createFormVersion(title: $title, fields: $fields) {
    id
  }
}
    `;

/**
 * __useCreateFormVersionMutation__
 *
 * To run a mutation, you first call `useCreateFormVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFormVersionMutation({
 *   variables: {
 *     title: // value for 'title'
 *     fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateFormVersionMutation(options: VueApolloComposable.UseMutationOptions<CreateFormVersionMutation, CreateFormVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateFormVersionMutation, CreateFormVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateFormVersionMutation, CreateFormVersionMutationVariables>(CreateFormVersionDocument, options);
}
export type CreateFormVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateFormVersionMutation, CreateFormVersionMutationVariables>;
export const DeleteFormVersionDocument = gql`
    mutation deleteFormVersion($id: ID!) {
  deleteFormVersion(id: $id)
}
    `;

/**
 * __useDeleteFormVersionMutation__
 *
 * To run a mutation, you first call `useDeleteFormVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFormVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormVersionMutation(options: VueApolloComposable.UseMutationOptions<DeleteFormVersionMutation, DeleteFormVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteFormVersionMutation, DeleteFormVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteFormVersionMutation, DeleteFormVersionMutationVariables>(DeleteFormVersionDocument, options);
}
export type DeleteFormVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteFormVersionMutation, DeleteFormVersionMutationVariables>;
export const EditFormVersionDocument = gql`
    mutation editFormVersion($id: ID!, $title: String!, $fields: [ScoreFieldInput!]!) {
  editFormVersion(id: $id, title: $title, fields: $fields)
}
    `;

/**
 * __useEditFormVersionMutation__
 *
 * To run a mutation, you first call `useEditFormVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditFormVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditFormVersionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     title: // value for 'title'
 *     fields: // value for 'fields'
 *   },
 * });
 */
export function useEditFormVersionMutation(options: VueApolloComposable.UseMutationOptions<EditFormVersionMutation, EditFormVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditFormVersionMutation, EditFormVersionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditFormVersionMutation, EditFormVersionMutationVariables>(EditFormVersionDocument, options);
}
export type EditFormVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditFormVersionMutation, EditFormVersionMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation deleteLocation($location: ID!) {
  deleteLocation(location: $location)
}
    `;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteLocationMutation({
 *   variables: {
 *     location: // value for 'location'
 *   },
 * });
 */
export function useDeleteLocationMutation(options: VueApolloComposable.UseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
}
export type DeleteLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const UpdateOrCreateLocationDocument = gql`
    mutation updateOrCreateLocation($location: ID, $title: String!, $biotope: ID, $geom: MapCoordinate, $project: ID) {
  updateOrCreateLocation(
    location: $location
    title: $title
    biotope: $biotope
    geom: $geom
    project: $project
  ) {
    id
  }
}
    `;

/**
 * __useUpdateOrCreateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrCreateLocationMutation({
 *   variables: {
 *     location: // value for 'location'
 *     title: // value for 'title'
 *     biotope: // value for 'biotope'
 *     geom: // value for 'geom'
 *     project: // value for 'project'
 *   },
 * });
 */
export function useUpdateOrCreateLocationMutation(options: VueApolloComposable.UseMutationOptions<UpdateOrCreateLocationMutation, UpdateOrCreateLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOrCreateLocationMutation, UpdateOrCreateLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOrCreateLocationMutation, UpdateOrCreateLocationMutationVariables>(UpdateOrCreateLocationDocument, options);
}
export type UpdateOrCreateLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOrCreateLocationMutation, UpdateOrCreateLocationMutationVariables>;
export const DeleteNetDocument = gql`
    mutation deleteNet($id: ID!) {
  deleteNet(id: $id)
}
    `;

/**
 * __useDeleteNetMutation__
 *
 * To run a mutation, you first call `useDeleteNetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteNetMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNetMutation(options: VueApolloComposable.UseMutationOptions<DeleteNetMutation, DeleteNetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteNetMutation, DeleteNetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteNetMutation, DeleteNetMutationVariables>(DeleteNetDocument, options);
}
export type DeleteNetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteNetMutation, DeleteNetMutationVariables>;
export const UpdateOrCreateNetDocument = gql`
    mutation updateOrCreateNet($visit: ID!, $net_data: NetInput!) {
  updateOrCreateNet(visit: $visit, net_data: $net_data) {
    id
  }
}
    `;

/**
 * __useUpdateOrCreateNetMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateNetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateNetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrCreateNetMutation({
 *   variables: {
 *     visit: // value for 'visit'
 *     net_data: // value for 'net_data'
 *   },
 * });
 */
export function useUpdateOrCreateNetMutation(options: VueApolloComposable.UseMutationOptions<UpdateOrCreateNetMutation, UpdateOrCreateNetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOrCreateNetMutation, UpdateOrCreateNetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOrCreateNetMutation, UpdateOrCreateNetMutationVariables>(UpdateOrCreateNetDocument, options);
}
export type UpdateOrCreateNetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOrCreateNetMutation, UpdateOrCreateNetMutationVariables>;
export const DeleteObservationDocument = gql`
    mutation deleteObservation($observation: ID!) {
  deleteObservation(observation: $observation)
}
    `;

/**
 * __useDeleteObservationMutation__
 *
 * To run a mutation, you first call `useDeleteObservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteObservationMutation({
 *   variables: {
 *     observation: // value for 'observation'
 *   },
 * });
 */
export function useDeleteObservationMutation(options: VueApolloComposable.UseMutationOptions<DeleteObservationMutation, DeleteObservationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteObservationMutation, DeleteObservationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteObservationMutation, DeleteObservationMutationVariables>(DeleteObservationDocument, options);
}
export type DeleteObservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteObservationMutation, DeleteObservationMutationVariables>;
export const UpdateOrCreateObservationDocument = gql`
    mutation updateOrCreateObservation($observation: ID, $capture: ID!, $date_start: Date!, $time_start: String!, $date_end: Date, $time_end: String, $geom: [Float], $activity: ID, $biotope: ID, $roost: ID, $accuracy: Int, $project: ID!, $photo: Upload) {
  updateOrCreateObservation(
    observation: $observation
    capture: $capture
    date_start: $date_start
    time_start: $time_start
    date_end: $date_end
    time_end: $time_end
    geom: $geom
    activity: $activity
    biotope: $biotope
    roost: $roost
    accuracy: $accuracy
    project: $project
    photo: $photo
  ) {
    id
  }
}
    `;

/**
 * __useUpdateOrCreateObservationMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateObservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateObservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrCreateObservationMutation({
 *   variables: {
 *     observation: // value for 'observation'
 *     capture: // value for 'capture'
 *     date_start: // value for 'date_start'
 *     time_start: // value for 'time_start'
 *     date_end: // value for 'date_end'
 *     time_end: // value for 'time_end'
 *     geom: // value for 'geom'
 *     activity: // value for 'activity'
 *     biotope: // value for 'biotope'
 *     roost: // value for 'roost'
 *     accuracy: // value for 'accuracy'
 *     project: // value for 'project'
 *     photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdateOrCreateObservationMutation(options: VueApolloComposable.UseMutationOptions<UpdateOrCreateObservationMutation, UpdateOrCreateObservationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOrCreateObservationMutation, UpdateOrCreateObservationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOrCreateObservationMutation, UpdateOrCreateObservationMutationVariables>(UpdateOrCreateObservationDocument, options);
}
export type UpdateOrCreateObservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOrCreateObservationMutation, UpdateOrCreateObservationMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($form: ID!, $involved_persons: [ID!], $manager: ID!, $number: String!, $title: String!) {
  createProject(
    form: $form
    involved_persons: $involved_persons
    manager: $manager
    number: $number
    title: $title
  ) {
    id
  }
}
    `;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProjectMutation({
 *   variables: {
 *     form: // value for 'form'
 *     involved_persons: // value for 'involved_persons'
 *     manager: // value for 'manager'
 *     number: // value for 'number'
 *     title: // value for 'title'
 *   },
 * });
 */
export function useCreateProjectMutation(options: VueApolloComposable.UseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
}
export type CreateProjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateProjectMutation, CreateProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation deleteProject($project: ID!) {
  deleteProject(project: $project)
}
    `;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProjectMutation({
 *   variables: {
 *     project: // value for 'project'
 *   },
 * });
 */
export function useDeleteProjectMutation(options: VueApolloComposable.UseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
}
export type DeleteProjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const EditProjectDocument = gql`
    mutation editProject($project: ID!, $form: ID!, $involved_persons: [ID!], $manager: ID!, $title: String!) {
  editProject(
    project: $project
    form: $form
    involved_persons: $involved_persons
    manager: $manager
    title: $title
  )
}
    `;

/**
 * __useEditProjectMutation__
 *
 * To run a mutation, you first call `useEditProjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditProjectMutation({
 *   variables: {
 *     project: // value for 'project'
 *     form: // value for 'form'
 *     involved_persons: // value for 'involved_persons'
 *     manager: // value for 'manager'
 *     title: // value for 'title'
 *   },
 * });
 */
export function useEditProjectMutation(options: VueApolloComposable.UseMutationOptions<EditProjectMutation, EditProjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditProjectMutation, EditProjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditProjectMutation, EditProjectMutationVariables>(EditProjectDocument, options);
}
export type EditProjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditProjectMutation, EditProjectMutationVariables>;
export const CreateVisitDocument = gql`
    mutation createVisit($date_start: Date!, $locations: [ID!]!, $project: ID!, $time_start: String, $cloudcover_type: ID, $fog_type: ID, $rain_type: ID, $temperature_start: Float, $wind_direction_type: ID, $windforce: Int, $date_end: Date, $time_end: String, $temperature_end: Float, $nets: [NetInput!]) {
  createVisit(
    cloudcover_type: $cloudcover_type
    date_start: $date_start
    fog_type: $fog_type
    locations: $locations
    project: $project
    rain_type: $rain_type
    temperature_start: $temperature_start
    time_start: $time_start
    wind_direction_type: $wind_direction_type
    windforce: $windforce
    date_end: $date_end
    time_end: $time_end
    temperature_end: $temperature_end
    nets: $nets
  ) {
    id
  }
}
    `;

/**
 * __useCreateVisitMutation__
 *
 * To run a mutation, you first call `useCreateVisitMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVisitMutation({
 *   variables: {
 *     date_start: // value for 'date_start'
 *     locations: // value for 'locations'
 *     project: // value for 'project'
 *     time_start: // value for 'time_start'
 *     cloudcover_type: // value for 'cloudcover_type'
 *     fog_type: // value for 'fog_type'
 *     rain_type: // value for 'rain_type'
 *     temperature_start: // value for 'temperature_start'
 *     wind_direction_type: // value for 'wind_direction_type'
 *     windforce: // value for 'windforce'
 *     date_end: // value for 'date_end'
 *     time_end: // value for 'time_end'
 *     temperature_end: // value for 'temperature_end'
 *     nets: // value for 'nets'
 *   },
 * });
 */
export function useCreateVisitMutation(options: VueApolloComposable.UseMutationOptions<CreateVisitMutation, CreateVisitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateVisitMutation, CreateVisitMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateVisitMutation, CreateVisitMutationVariables>(CreateVisitDocument, options);
}
export type CreateVisitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateVisitMutation, CreateVisitMutationVariables>;
export const DeleteVisitDocument = gql`
    mutation deleteVisit($visit: ID!) {
  deleteVisit(visit: $visit)
}
    `;

/**
 * __useDeleteVisitMutation__
 *
 * To run a mutation, you first call `useDeleteVisitMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisitMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteVisitMutation({
 *   variables: {
 *     visit: // value for 'visit'
 *   },
 * });
 */
export function useDeleteVisitMutation(options: VueApolloComposable.UseMutationOptions<DeleteVisitMutation, DeleteVisitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteVisitMutation, DeleteVisitMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteVisitMutation, DeleteVisitMutationVariables>(DeleteVisitDocument, options);
}
export type DeleteVisitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteVisitMutation, DeleteVisitMutationVariables>;
export const EditVisitDocument = gql`
    mutation editVisit($visit: ID!, $date_start: Date!, $locations: [ID!]!, $time_start: String, $cloudcover_type: ID, $fog_type: ID, $rain_type: ID, $temperature_start: Float, $wind_direction_type: ID, $windforce: Int, $date_end: Date, $time_end: String, $temperature_end: Float) {
  editVisit(
    visit: $visit
    cloudcover_type: $cloudcover_type
    date_start: $date_start
    fog_type: $fog_type
    locations: $locations
    rain_type: $rain_type
    temperature_start: $temperature_start
    time_start: $time_start
    wind_direction_type: $wind_direction_type
    windforce: $windforce
    date_end: $date_end
    time_end: $time_end
    temperature_end: $temperature_end
  )
}
    `;

/**
 * __useEditVisitMutation__
 *
 * To run a mutation, you first call `useEditVisitMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditVisitMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditVisitMutation({
 *   variables: {
 *     visit: // value for 'visit'
 *     date_start: // value for 'date_start'
 *     locations: // value for 'locations'
 *     time_start: // value for 'time_start'
 *     cloudcover_type: // value for 'cloudcover_type'
 *     fog_type: // value for 'fog_type'
 *     rain_type: // value for 'rain_type'
 *     temperature_start: // value for 'temperature_start'
 *     wind_direction_type: // value for 'wind_direction_type'
 *     windforce: // value for 'windforce'
 *     date_end: // value for 'date_end'
 *     time_end: // value for 'time_end'
 *     temperature_end: // value for 'temperature_end'
 *   },
 * });
 */
export function useEditVisitMutation(options: VueApolloComposable.UseMutationOptions<EditVisitMutation, EditVisitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditVisitMutation, EditVisitMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditVisitMutation, EditVisitMutationVariables>(EditVisitDocument, options);
}
export type EditVisitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditVisitMutation, EditVisitMutationVariables>;
export const EndVisitDocument = gql`
    mutation endVisit($visit: ID!, $date_end: Date, $time_end: String, $temperature_end: Float) {
  endVisit(
    visit: $visit
    date_end: $date_end
    time_end: $time_end
    temperature_end: $temperature_end
  ) {
    id
  }
}
    `;

/**
 * __useEndVisitMutation__
 *
 * To run a mutation, you first call `useEndVisitMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEndVisitMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEndVisitMutation({
 *   variables: {
 *     visit: // value for 'visit'
 *     date_end: // value for 'date_end'
 *     time_end: // value for 'time_end'
 *     temperature_end: // value for 'temperature_end'
 *   },
 * });
 */
export function useEndVisitMutation(options: VueApolloComposable.UseMutationOptions<EndVisitMutation, EndVisitMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EndVisitMutation, EndVisitMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EndVisitMutation, EndVisitMutationVariables>(EndVisitDocument, options);
}
export type EndVisitMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EndVisitMutation, EndVisitMutationVariables>;
export const DashboardDocument = gql`
    query dashboard($limit: Int) {
  lastObservations: observations(limit: $limit) {
    id
    start
    capture {
      bat
    }
  }
  lastVisits: visits(limit: $limit) {
    id
    start
    captures_count
    verified
    observer {
      id
      name
    }
    project {
      id
      title
    }
  }
  lastProjects: projects(limit: $limit) {
    id
    created_at
    title
    captures_count
    last_visit {
      start
      verified
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a Vue component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDashboardQuery({
 *   limit: // value for 'limit'
 * });
 */
export function useDashboardQuery(variables: DashboardQueryVariables | VueCompositionApi.Ref<DashboardQueryVariables> | ReactiveFunction<DashboardQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DashboardQuery, DashboardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardQuery, DashboardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardQuery, DashboardQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, variables, options);
}
export function useDashboardLazyQuery(variables: DashboardQueryVariables | VueCompositionApi.Ref<DashboardQueryVariables> | ReactiveFunction<DashboardQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<DashboardQuery, DashboardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardQuery, DashboardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardQuery, DashboardQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, variables, options);
}
export type DashboardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DashboardQuery, DashboardQueryVariables>;
export const SpeciesTypesDocument = gql`
    query speciesTypes {
  speciesTypes {
    id
    title
  }
}
    `;

/**
 * __useSpeciesTypesQuery__
 *
 * To run a query within a Vue component, call `useSpeciesTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeciesTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSpeciesTypesQuery();
 */
export function useSpeciesTypesQuery(options: VueApolloComposable.UseQueryOptions<SpeciesTypesQuery, SpeciesTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SpeciesTypesQuery, SpeciesTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SpeciesTypesQuery, SpeciesTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SpeciesTypesQuery, SpeciesTypesQueryVariables>(SpeciesTypesDocument, {}, options);
}
export function useSpeciesTypesLazyQuery(options: VueApolloComposable.UseQueryOptions<SpeciesTypesQuery, SpeciesTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SpeciesTypesQuery, SpeciesTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SpeciesTypesQuery, SpeciesTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SpeciesTypesQuery, SpeciesTypesQueryVariables>(SpeciesTypesDocument, {}, options);
}
export type SpeciesTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SpeciesTypesQuery, SpeciesTypesQueryVariables>;
export const FormVersionDocument = gql`
    query formVersion($id: ID!) {
  formVersion(id: $id) {
    id
    title
    projects_count
    score_fields {
      id
      category
      field_name
      field_values {
        id
        score_value
        definition
      }
    }
    capabilities {
      name
    }
  }
}
    `;

/**
 * __useFormVersionQuery__
 *
 * To run a query within a Vue component, call `useFormVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormVersionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormVersionQuery({
 *   id: // value for 'id'
 * });
 */
export function useFormVersionQuery(variables: FormVersionQueryVariables | VueCompositionApi.Ref<FormVersionQueryVariables> | ReactiveFunction<FormVersionQueryVariables>, options: VueApolloComposable.UseQueryOptions<FormVersionQuery, FormVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FormVersionQuery, FormVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FormVersionQuery, FormVersionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FormVersionQuery, FormVersionQueryVariables>(FormVersionDocument, variables, options);
}
export function useFormVersionLazyQuery(variables: FormVersionQueryVariables | VueCompositionApi.Ref<FormVersionQueryVariables> | ReactiveFunction<FormVersionQueryVariables>, options: VueApolloComposable.UseQueryOptions<FormVersionQuery, FormVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FormVersionQuery, FormVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FormVersionQuery, FormVersionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FormVersionQuery, FormVersionQueryVariables>(FormVersionDocument, variables, options);
}
export type FormVersionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FormVersionQuery, FormVersionQueryVariables>;
export const FormVersionsDocument = gql`
    query formVersions {
  formVersions {
    id
    title
    capabilities {
      name
    }
  }
}
    `;

/**
 * __useFormVersionsQuery__
 *
 * To run a query within a Vue component, call `useFormVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormVersionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormVersionsQuery();
 */
export function useFormVersionsQuery(options: VueApolloComposable.UseQueryOptions<FormVersionsQuery, FormVersionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FormVersionsQuery, FormVersionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FormVersionsQuery, FormVersionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FormVersionsQuery, FormVersionsQueryVariables>(FormVersionsDocument, {}, options);
}
export function useFormVersionsLazyQuery(options: VueApolloComposable.UseQueryOptions<FormVersionsQuery, FormVersionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FormVersionsQuery, FormVersionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FormVersionsQuery, FormVersionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FormVersionsQuery, FormVersionsQueryVariables>(FormVersionsDocument, {}, options);
}
export type FormVersionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FormVersionsQuery, FormVersionsQueryVariables>;
export const LocationsDocument = gql`
    query locations($project: ID) {
  locations(project: $project) {
    id
    title
    biotope {
      id
      title
    }
    setup {
      id
      geom
    }
    capabilities {
      name
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a Vue component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLocationsQuery({
 *   project: // value for 'project'
 * });
 */
export function useLocationsQuery(variables: LocationsQueryVariables | VueCompositionApi.Ref<LocationsQueryVariables> | ReactiveFunction<LocationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<LocationsQuery, LocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LocationsQuery, LocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LocationsQuery, LocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, variables, options);
}
export function useLocationsLazyQuery(variables: LocationsQueryVariables | VueCompositionApi.Ref<LocationsQueryVariables> | ReactiveFunction<LocationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<LocationsQuery, LocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LocationsQuery, LocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LocationsQuery, LocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, variables, options);
}
export type LocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LocationsQuery, LocationsQueryVariables>;
export const LocationOptionsDocument = gql`
    query locationOptions @cache(ttl: 15) {
  setupTypes {
    id
    title
  }
  methodTypes {
    id
    title
  }
  biotopeTypes {
    id
    title
  }
}
    `;

/**
 * __useLocationOptionsQuery__
 *
 * To run a query within a Vue component, call `useLocationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLocationOptionsQuery();
 */
export function useLocationOptionsQuery(options: VueApolloComposable.UseQueryOptions<LocationOptionsQuery, LocationOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LocationOptionsQuery, LocationOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LocationOptionsQuery, LocationOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LocationOptionsQuery, LocationOptionsQueryVariables>(LocationOptionsDocument, {}, options);
}
export function useLocationOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<LocationOptionsQuery, LocationOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LocationOptionsQuery, LocationOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LocationOptionsQuery, LocationOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LocationOptionsQuery, LocationOptionsQueryVariables>(LocationOptionsDocument, {}, options);
}
export type LocationOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LocationOptionsQuery, LocationOptionsQueryVariables>;
export const NetsPerVisitDocument = gql`
    query netsPerVisit($visit: ID!, $location: ID) {
  netsPerVisit(visit: $visit, location: $location) {
    id
    title
    method {
      id
    }
    setup {
      id
    }
    lure
    length
    height_min
    height_max
    capabilities {
      name
    }
  }
}
    `;

/**
 * __useNetsPerVisitQuery__
 *
 * To run a query within a Vue component, call `useNetsPerVisitQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetsPerVisitQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNetsPerVisitQuery({
 *   visit: // value for 'visit'
 *   location: // value for 'location'
 * });
 */
export function useNetsPerVisitQuery(variables: NetsPerVisitQueryVariables | VueCompositionApi.Ref<NetsPerVisitQueryVariables> | ReactiveFunction<NetsPerVisitQueryVariables>, options: VueApolloComposable.UseQueryOptions<NetsPerVisitQuery, NetsPerVisitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NetsPerVisitQuery, NetsPerVisitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NetsPerVisitQuery, NetsPerVisitQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NetsPerVisitQuery, NetsPerVisitQueryVariables>(NetsPerVisitDocument, variables, options);
}
export function useNetsPerVisitLazyQuery(variables: NetsPerVisitQueryVariables | VueCompositionApi.Ref<NetsPerVisitQueryVariables> | ReactiveFunction<NetsPerVisitQueryVariables>, options: VueApolloComposable.UseQueryOptions<NetsPerVisitQuery, NetsPerVisitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NetsPerVisitQuery, NetsPerVisitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NetsPerVisitQuery, NetsPerVisitQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NetsPerVisitQuery, NetsPerVisitQueryVariables>(NetsPerVisitDocument, variables, options);
}
export type NetsPerVisitQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NetsPerVisitQuery, NetsPerVisitQueryVariables>;
export const CapturesDocument = gql`
    query captures($project: ID!) {
  captures(project: $project) {
    id
    title: bat
  }
}
    `;

/**
 * __useCapturesQuery__
 *
 * To run a query within a Vue component, call `useCapturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapturesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCapturesQuery({
 *   project: // value for 'project'
 * });
 */
export function useCapturesQuery(variables: CapturesQueryVariables | VueCompositionApi.Ref<CapturesQueryVariables> | ReactiveFunction<CapturesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CapturesQuery, CapturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CapturesQuery, CapturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CapturesQuery, CapturesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CapturesQuery, CapturesQueryVariables>(CapturesDocument, variables, options);
}
export function useCapturesLazyQuery(variables: CapturesQueryVariables | VueCompositionApi.Ref<CapturesQueryVariables> | ReactiveFunction<CapturesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CapturesQuery, CapturesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CapturesQuery, CapturesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CapturesQuery, CapturesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CapturesQuery, CapturesQueryVariables>(CapturesDocument, variables, options);
}
export type CapturesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CapturesQuery, CapturesQueryVariables>;
export const ObservationDocument = gql`
    query observation($id: ID!) {
  observation(id: $id) {
    id
    start
    end
    capture {
      bat
    }
    observer {
      id
      name
    }
    geom
    images
  }
}
    `;

/**
 * __useObservationQuery__
 *
 * To run a query within a Vue component, call `useObservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useObservationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useObservationQuery({
 *   id: // value for 'id'
 * });
 */
export function useObservationQuery(variables: ObservationQueryVariables | VueCompositionApi.Ref<ObservationQueryVariables> | ReactiveFunction<ObservationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ObservationQuery, ObservationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObservationQuery, ObservationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObservationQuery, ObservationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ObservationQuery, ObservationQueryVariables>(ObservationDocument, variables, options);
}
export function useObservationLazyQuery(variables: ObservationQueryVariables | VueCompositionApi.Ref<ObservationQueryVariables> | ReactiveFunction<ObservationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ObservationQuery, ObservationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObservationQuery, ObservationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObservationQuery, ObservationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ObservationQuery, ObservationQueryVariables>(ObservationDocument, variables, options);
}
export type ObservationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ObservationQuery, ObservationQueryVariables>;
export const ObservationsDocument = gql`
    query observations {
  observations {
    id
    start
    capture {
      id
      bat
    }
    capabilities {
      name
    }
    geom
    project {
      id
    }
    observer {
      id
      name
    }
    roost {
      id
    }
    activity {
      id
    }
    biotope {
      id
    }
    accuracy
    end
    images
  }
}
    `;

/**
 * __useObservationsQuery__
 *
 * To run a query within a Vue component, call `useObservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObservationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useObservationsQuery();
 */
export function useObservationsQuery(options: VueApolloComposable.UseQueryOptions<ObservationsQuery, ObservationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObservationsQuery, ObservationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObservationsQuery, ObservationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ObservationsQuery, ObservationsQueryVariables>(ObservationsDocument, {}, options);
}
export function useObservationsLazyQuery(options: VueApolloComposable.UseQueryOptions<ObservationsQuery, ObservationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObservationsQuery, ObservationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObservationsQuery, ObservationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ObservationsQuery, ObservationsQueryVariables>(ObservationsDocument, {}, options);
}
export type ObservationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ObservationsQuery, ObservationsQueryVariables>;
export const ObservationOptionsDocument = gql`
    query observationOptions @cache(ttl: 15) {
  biotopeTypes {
    id
    title
  }
  activityTypes {
    id
    title
  }
  roostTypes {
    id
    title
  }
}
    `;

/**
 * __useObservationOptionsQuery__
 *
 * To run a query within a Vue component, call `useObservationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObservationOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useObservationOptionsQuery();
 */
export function useObservationOptionsQuery(options: VueApolloComposable.UseQueryOptions<ObservationOptionsQuery, ObservationOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObservationOptionsQuery, ObservationOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObservationOptionsQuery, ObservationOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ObservationOptionsQuery, ObservationOptionsQueryVariables>(ObservationOptionsDocument, {}, options);
}
export function useObservationOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<ObservationOptionsQuery, ObservationOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ObservationOptionsQuery, ObservationOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ObservationOptionsQuery, ObservationOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ObservationOptionsQuery, ObservationOptionsQueryVariables>(ObservationOptionsDocument, {}, options);
}
export type ObservationOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ObservationOptionsQuery, ObservationOptionsQueryVariables>;
export const PageDocument = gql`
    query page($segments: String!) {
  page(segments: $segments) {
    active_image
    seo {
      meta_title
      meta_description
      meta_index
      meta_follow
    }
    slug
    title
    url
  }
}
    `;

/**
 * __usePageQuery__
 *
 * To run a query within a Vue component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePageQuery({
 *   segments: // value for 'segments'
 * });
 */
export function usePageQuery(variables: PageQueryVariables | VueCompositionApi.Ref<PageQueryVariables> | ReactiveFunction<PageQueryVariables>, options: VueApolloComposable.UseQueryOptions<PageQuery, PageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PageQuery, PageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PageQuery, PageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PageQuery, PageQueryVariables>(PageDocument, variables, options);
}
export function usePageLazyQuery(variables: PageQueryVariables | VueCompositionApi.Ref<PageQueryVariables> | ReactiveFunction<PageQueryVariables>, options: VueApolloComposable.UseQueryOptions<PageQuery, PageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PageQuery, PageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PageQuery, PageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, variables, options);
}
export type PageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PageQuery, PageQueryVariables>;
export const ProjectOptionsDocument = gql`
    query projectOptions @cache(ttl: 15) {
  persons {
    id
    name
  }
  formVersions {
    id
    title
  }
}
    `;

/**
 * __useProjectOptionsQuery__
 *
 * To run a query within a Vue component, call `useProjectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectOptionsQuery();
 */
export function useProjectOptionsQuery(options: VueApolloComposable.UseQueryOptions<ProjectOptionsQuery, ProjectOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectOptionsQuery, ProjectOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectOptionsQuery, ProjectOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectOptionsQuery, ProjectOptionsQueryVariables>(ProjectOptionsDocument, {}, options);
}
export function useProjectOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<ProjectOptionsQuery, ProjectOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectOptionsQuery, ProjectOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectOptionsQuery, ProjectOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectOptionsQuery, ProjectOptionsQueryVariables>(ProjectOptionsDocument, {}, options);
}
export type ProjectOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectOptionsQuery, ProjectOptionsQueryVariables>;
export const ProjectDocument = gql`
    query project($id: ID!) {
  project(id: $id) {
    id
    title
    created_at
    captures_count
    form {
      id
    }
    capabilities {
      name
    }
    involved {
      id
      name
    }
    manager {
      id
      name
    }
    visits {
      id
      start
      captures_count
      temperature_start
      verified
      observer {
        id
        name
      }
      cloud_cover_type {
        id
        title
      }
      fog_type {
        id
        title
      }
      rainfall_type {
        id
        title
      }
      wind_direction_type {
        id
        title
      }
      locations {
        id
        title
      }
      captures {
        id
        bat
        verified
        date
        time
        species {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useProjectQuery__
 *
 * To run a query within a Vue component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectQuery({
 *   id: // value for 'id'
 * });
 */
export function useProjectQuery(variables: ProjectQueryVariables | VueCompositionApi.Ref<ProjectQueryVariables> | ReactiveFunction<ProjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, variables, options);
}
export function useProjectLazyQuery(variables: ProjectQueryVariables | VueCompositionApi.Ref<ProjectQueryVariables> | ReactiveFunction<ProjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectQuery, ProjectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, variables, options);
}
export type ProjectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectQuery, ProjectQueryVariables>;
export const ProjectsDocument = gql`
    query projects($query: String, $sort: String) {
  projects(query: $query, sort: $sort) {
    id
    title
    capabilities {
      name
    }
    involved {
      id
      name
    }
    captures_count
    last_visit {
      end
      start
      verified
    }
  }
}
    `;

/**
 * __useProjectsQuery__
 *
 * To run a query within a Vue component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProjectsQuery({
 *   query: // value for 'query'
 *   sort: // value for 'sort'
 * });
 */
export function useProjectsQuery(variables: ProjectsQueryVariables | VueCompositionApi.Ref<ProjectsQueryVariables> | ReactiveFunction<ProjectsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, variables, options);
}
export function useProjectsLazyQuery(variables: ProjectsQueryVariables | VueCompositionApi.Ref<ProjectsQueryVariables> | ReactiveFunction<ProjectsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProjectsQuery, ProjectsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, variables, options);
}
export type ProjectsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProjectsQuery, ProjectsQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    uuid
    first_name
    name
    email
    capabilities
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a Vue component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMeQuery();
 */
export function useMeQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export function useMeLazyQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export type MeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MeQuery, MeQueryVariables>;
export const VisitOptionsDocument = gql`
    query visitOptions @cache(ttl: 15) {
  cloudcoverTypes {
    id
    title
  }
  directionTypes {
    id
    title
  }
  rainfallTypes {
    id
    title
  }
  fogTypes {
    id
    title
  }
}
    `;

/**
 * __useVisitOptionsQuery__
 *
 * To run a query within a Vue component, call `useVisitOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVisitOptionsQuery();
 */
export function useVisitOptionsQuery(options: VueApolloComposable.UseQueryOptions<VisitOptionsQuery, VisitOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VisitOptionsQuery, VisitOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VisitOptionsQuery, VisitOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VisitOptionsQuery, VisitOptionsQueryVariables>(VisitOptionsDocument, {}, options);
}
export function useVisitOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<VisitOptionsQuery, VisitOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VisitOptionsQuery, VisitOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VisitOptionsQuery, VisitOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VisitOptionsQuery, VisitOptionsQueryVariables>(VisitOptionsDocument, {}, options);
}
export type VisitOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VisitOptionsQuery, VisitOptionsQueryVariables>;
export const VisitDocument = gql`
    query visit($id: ID!) {
  visit(id: $id) {
    id
    start
    end
    temperature_start
    temperature_end
    wind_force
    capabilities {
      name
    }
    cloud_cover_type {
      id
      title
    }
    fog_type {
      id
      title
    }
    rainfall_type {
      id
      title
    }
    wind_direction_type {
      id
      title
    }
    locations {
      id
      title
    }
    nets {
      id
      title
    }
    captures {
      id
      direction
      has_escaped
      bat_sex
      bat
      forearm_length
      fifthfinger
      weight
      count_spint
      count_parasite
      comment
      chinspot
      epi
      bold_molt
      dental_wear
      dental_plaque
      buccalglands
      age
      testes
      nipple_bold
      epididymis_size
      epididymis_fill
      sexualstatus
      bat_sex
      mammaryglands
      teat_size
      teat_hair
      date
      time
      verified
      photo
      tag
      transponder
      ring
      observations {
        id
      }
      capabilities {
        name
      }
      species {
        id
        title
      }
      location {
        id
      }
      net {
        id
      }
    }
    project {
      id
      title
      form {
        id
        score_fields {
          id
          field_name
          source
          category
          field_values {
            id
            score_value
            definition
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVisitQuery__
 *
 * To run a query within a Vue component, call `useVisitQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVisitQuery({
 *   id: // value for 'id'
 * });
 */
export function useVisitQuery(variables: VisitQueryVariables | VueCompositionApi.Ref<VisitQueryVariables> | ReactiveFunction<VisitQueryVariables>, options: VueApolloComposable.UseQueryOptions<VisitQuery, VisitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VisitQuery, VisitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VisitQuery, VisitQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VisitQuery, VisitQueryVariables>(VisitDocument, variables, options);
}
export function useVisitLazyQuery(variables: VisitQueryVariables | VueCompositionApi.Ref<VisitQueryVariables> | ReactiveFunction<VisitQueryVariables>, options: VueApolloComposable.UseQueryOptions<VisitQuery, VisitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VisitQuery, VisitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VisitQuery, VisitQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VisitQuery, VisitQueryVariables>(VisitDocument, variables, options);
}
export type VisitQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VisitQuery, VisitQueryVariables>;
export const VisitsDocument = gql`
    query visits {
  visits {
    id
    captures_count
    start
    temperature_end
    temperature_start
    verified
    wind_force
    capabilities {
      name
    }
    captures {
      id
      bat
      verified
      date
      time
      species {
        id
        title
      }
    }
    cloud_cover_type {
      id
      title
    }
    fog_type {
      id
      title
    }
    locations {
      id
      title
    }
    observer {
      id
      name
    }
    project {
      id
      title
      involved {
        name
      }
    }
    rainfall_type {
      id
      title
    }
    wind_direction_type {
      id
      title
    }
  }
}
    `;

/**
 * __useVisitsQuery__
 *
 * To run a query within a Vue component, call `useVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVisitsQuery();
 */
export function useVisitsQuery(options: VueApolloComposable.UseQueryOptions<VisitsQuery, VisitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VisitsQuery, VisitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VisitsQuery, VisitsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VisitsQuery, VisitsQueryVariables>(VisitsDocument, {}, options);
}
export function useVisitsLazyQuery(options: VueApolloComposable.UseQueryOptions<VisitsQuery, VisitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VisitsQuery, VisitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VisitsQuery, VisitsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VisitsQuery, VisitsQueryVariables>(VisitsDocument, {}, options);
}
export type VisitsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VisitsQuery, VisitsQueryVariables>;